module.exports = __webpack_public_path__ + "img/line-chart-up-01.0b312142.svg";